import React from 'react';
import { blue60 } from "../../vars";

const Card = ({ width = 14, height = 14, color = 'currentColor', className = '' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512" width={width} height={height} stroke={color} fill={color}><rect x="48" y="96" width="416" height="320" rx="56" ry="56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" /><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="60" d="M48 192h416M128 300h48v20h-48z" /></svg>
    );
};

export default Card;